export default "/Frontend/dist/pdf-white.79d01d000d7fb7db2d6f4d27ccf3b715.svg";